(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zirla-custom-orders"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zirla-custom-orders')) {
    customElements.define('zirla-custom-orders', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const project = this.querySelector('[data-zr-project]');
        const groups = Array.from(this.querySelectorAll('[data-zr-fields]'));
        const values = { stickers: 'Custom stickers', tshirts: 'Custom T-shirts', hats: 'Custom hats' };
        const update = () => {
          groups.forEach(group => {
            const active = values[group.dataset.zrFields] === project.value;
            group.hidden = !active;
            group.disabled = !active;
          });
        };
        if (project) {
          update();
          project.addEventListener('change', update);
          this.querySelectorAll('[data-zr-service]').forEach(link => {
            link.addEventListener('click', () => {
              project.value = values[link.dataset.zrService];
              update();
              project.focus({ preventScroll: true });
            });
          });
          project.form.addEventListener('reset', () => requestAnimationFrame(update));
        }
        const result = this.querySelector('[data-zr-result]');
        if (result && !window.Shopify?.designMode) {
          result.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
